import moment from 'moment';
import 'moment-timezone';

export function formatWithTimeZoneSuffix(formattedDate: string, date: string | Date | null | undefined, timeZone: string | undefined) {
  if (!date || !timeZone || timeZone === moment.tz.guess()) {
    return formattedDate;
  }

  const momentDate = date instanceof Date
    ? moment(date).tz(timeZone)
    : moment(date, moment.ISO_8601, true).tz(timeZone);
  if (!momentDate.isValid()) {
    return formattedDate;
  }

  const timeZoneAbbreviation = momentDate.format('z');
  return timeZoneAbbreviation ? `${formattedDate} ${timeZoneAbbreviation}` : formattedDate;
}
